interface SearchUsersToolProps {
  args: {
    query: string;
    role?: string;
    limit?: number;
    status?: string;
  };
  result?: string;
  status?: "running" | "complete" | "error";
}

export function SearchUsersTool({
  args,
  result,
  status,
}: SearchUsersToolProps) {
  // Parse the result if available
  let parsedResult: any = null;
  if (result) {
    try {
      parsedResult = JSON.parse(result);
    } catch (e) {
      console.warn("Failed to parse search users result:", result);
    }
  }

  return (
    <div>
      {/* Show search parameters as simple text */}
      <div className="space-y-1 text-sm text-gray-500">
        <div>Query: &ldquo;{args.query}&rdquo;</div>
        {args.role && <div>Role: {args.role}</div>}
        {args.limit && <div>Limit: {args.limit}</div>}
      </div>

      {/* Show structured results when complete */}
      {parsedResult && status === "complete" && (
        <div className="mt-3">
          {parsedResult.found && (
            <div className="mb-2 text-sm text-gray-600">
              Found {parsedResult.found} user
              {parsedResult.found !== 1 ? "s" : ""}
            </div>
          )}

          {parsedResult.users && parsedResult.users.length > 0 && (
            <div className="space-y-2">
              {parsedResult.users
                .slice(0, 3)
                .map((user: any, index: number) => (
                  <div
                    key={user.id || index}
                    className="rounded-md bg-gray-50 p-3"
                  >
                    <div className="mb-2 flex items-center gap-2">
                      <span className="font-medium text-gray-900">
                        {user.name}
                      </span>
                      <span className="inline-block rounded bg-green-100 px-2 py-0.5 text-xs font-medium uppercase text-green-800">
                        {user.role}
                      </span>
                    </div>
                    <div className="space-y-1 text-sm text-gray-600">
                      {user.email && <div>📧 {user.email}</div>}
                      {user.phone && <div>📞 {user.phone}</div>}
                      {user.assigned_groups &&
                        user.assigned_groups.length > 0 && (
                          <div>
                            📍{" "}
                            {user.assigned_groups
                              .map((g: { name: string }) => g.name)
                              .join(", ")}
                          </div>
                        )}
                      {user.deactivated && (
                        <div className="text-xs text-red-600">
                          ⚠️ Deactivated
                        </div>
                      )}
                    </div>
                  </div>
                ))}

              {parsedResult.users.length > 3 && (
                <div className="text-sm text-gray-500">
                  +{parsedResult.users.length - 3} more users
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
